import _implicitStylesheets from "./filter.css";
import _implicitScopedStylesheets from "./filter.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<label${"a0:for"}${3}>${"t1"}</label>`;
const $fragment2 = parseFragment`<option value=""${3}>${"t1"}</option>`;
const $fragment3 = parseFragment`<option selected${"a0:value"}${3}>${"t1"}</option>`;
const $fragment4 = parseFragment`<option${"a0:value"}${3}>${"t1"}</option>`;
const stc0 = {
  classMap: {
    "axwp-filters__filter": true
  },
  key: 0
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, k: api_key, i: api_iterator, f: api_flatten, h: api_element} = $api;
  const {_m0} = $ctx;
  return [$cmp.hasOptions ? api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    attrs: {
      "for": api_scoped_id($cmp.filterType)
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.label))]), api_element("select", {
    attrs: {
      "id": api_scoped_id($cmp.filterType),
      "name": $cmp.filterType
    },
    key: 3,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleFilterChange))
    }
  }, api_flatten([api_static_fragment($fragment2, 5, [api_static_part(1, null, api_dynamic_text($cmp.labels.filterAllOption))]), api_iterator($cmp.options, function (filterItem) {
    return [filterItem.selected ? api_static_fragment($fragment3, api_key(7, filterItem.slug), [api_static_part(0, {
      attrs: {
        "value": filterItem.slug
      }
    }, null), api_static_part(1, null, api_dynamic_text(filterItem.plural))]) : null, !filterItem.selected ? api_static_fragment($fragment4, api_key(9, filterItem.slug), [api_static_part(0, {
      attrs: {
        "value": filterItem.slug
      }
    }, null), api_static_part(1, null, api_dynamic_text(filterItem.plural))]) : null];
  })]))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-750v3o3u45b";
tmpl.legacyStylesheetToken = "undefined-_filter";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
